export const excludeKeys = (
  props: Record<string, any> = {},
  ...exclude: string[]
) =>
  Object.keys(props)
    .filter((key) => exclude.indexOf(key) === -1)
    .reduce((acc: any, key) => {
      acc[key] = props[key];
      return acc;
    }, {});
